import { SAGITTAL_LIMITATION } from "@/lib/sagittal";

const TONE = { "próximo da referência": "text-sky-300", ligeiro: "text-emerald-300", moderado: "text-amber-300", acentuado: "text-rose-300" };
const ORIENT = [["", "Automática"], ["left", "Virado para a esquerda"], ["right", "Virado para a direita"]];

function Orientation({ result, value, onChange }) {
  const o = result.orientation;
  return (
    <div className="flex flex-wrap items-center gap-2 text-xs" data-testid="sagittal-orientation">
      <span className="text-slate-400">Orientação: {o ? `${o.facing > 0 ? "virado para a direita" : "virado para a esquerda"} · ${o.source}` : "indeterminada"}</span>
      {(!o || !o.confident) && <span className="text-amber-300" data-testid="sagittal-orientation-warning">Confirme a orientação</span>}
      {onChange && ORIENT.map(([v, l]) => (
        <button key={v || "auto"} type="button" onClick={() => onChange(v)} data-testid={`sagittal-orient-${v || "auto"}`}
          className={`rounded-full border px-2.5 py-1 transition-colors ${(value || "") === v ? "border-sky-500/60 text-sky-200 bg-sky-500/10" : "border-slate-700 text-slate-400 hover:border-slate-500"}`}>{l}</button>
      ))}
    </div>
  );
}

// Cartão «Alinhamento Postural Sagital Estimado»: versão profissional (detalhe) ou do paciente (simplificada).
export default function SagittalAlignmentCard({ result, variant = "professional", orientationValue, onOrientationChange }) {
  if (!result) return null;
  const pro = variant === "professional";
  return (
    <section className="rounded-2xl border border-slate-800 bg-slate-900/55 p-5 space-y-4" data-testid={`sagittal-card-${variant}`}>
      <div>
        <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-sky-300">Vista lateral · estimativa visual</div>
        <h3 className="mt-1 font-display text-lg text-slate-50">{pro ? "Alinhamento Postural Sagital Estimado" : "Alinhamento postural visto de lado"}</h3>
      </div>
      {pro && <Orientation result={result} value={orientationValue} onChange={onOrientationChange} />}
      {!result.available ? (
        <p className="text-sm text-slate-400" data-testid="sagittal-unavailable">{result.reason}</p>
      ) : pro ? (
        <div className="overflow-x-auto">
          <table className="w-full text-xs" data-testid="sagittal-table">
            <thead><tr className="text-left text-[10px] uppercase tracking-wider text-slate-500">
              <th className="py-1.5 pr-3">Referência</th><th className="pr-3">Observação</th><th className="pr-3">Cálculo geométrico (estimado)</th><th>Inferência funcional</th>
            </tr></thead>
            <tbody className="text-slate-300">
              {result.points.map((p) => (
                <tr key={p.key} className="border-t border-slate-800" data-testid={`sagittal-row-${p.key}`}>
                  <td className="py-2 pr-3 text-slate-200">{p.label}</td>
                  <td className={`pr-3 ${TONE[p.category]}`}>{p.direction ? `Desvio ${p.direction} ${p.category}` : "Alinhamento próximo da referência"}</td>
                  <td className="pr-3 font-mono">≈ {p.dev > 0 ? "+" : ""}{p.dev}% da altura orelha–tornozelo</td>
                  <td>{p.inference}</td>
                </tr>
              ))}
              <tr className="border-t border-slate-800" data-testid="sagittal-row-global">
                <td className="py-2 pr-3 text-slate-200">Tornozelo · inclinação global</td>
                <td className={`pr-3 ${TONE[result.global.category]}`}>{result.global.direction ? `${result.global.direction === "anterior" ? "Anterior" : "Posterior"} ${result.global.category}` : "Próxima da vertical"}</td>
                <td className="pr-3 font-mono">≈ {result.global.deg}° (orelha → tornozelo)</td>
                <td>{result.global.inference}</td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : (
        <ul className="space-y-1.5 text-sm text-slate-300" data-testid="sagittal-patient-list">
          {[...result.points.map((p) => p.patient), result.global.patient].map((t, i) => <li key={i}>• {t}</li>)}
        </ul>
      )}
      <p className="text-[11px] leading-relaxed text-slate-500" data-testid="sagittal-limitation">
        {pro ? `${SAGITTAL_LIMITATION} Categorias (próximo, ligeiro, moderado, acentuado) são indicativas e não têm validação clínica; não alteram a pontuação.`
          : "Estimativa visual feita a partir da fotografia, explicada pelo profissional na consulta. Não é uma medição exata."}
      </p>
    </section>
  );
}
